import { createContext, useContext, useMemo, useRef, useState } from "react";

import MeasureComponent from "Utilities/Measurements/MeasureComponent";

const CellMeasurementsContext = createContext({});

export const CELL_MIN_WIDTH_IN_PX = 150;
const CELL_MAX_WIDTH_IN_PX = 300;
const MARGIN_IN_PX = 6;

export function CellMeasurementsParentProvider({ children }) {
  const [measurementsUpdated, setMeasurementsUpdated] = useState(1);

  const columnWidths = useRef({});

  const setWidthMeasurement = (columnID, width) => {
    const newWidth = Math.ceil(
      Math.min(
        Math.max(width + MARGIN_IN_PX, CELL_MIN_WIDTH_IN_PX),
        CELL_MAX_WIDTH_IN_PX
      )
    );

    if (
      columnWidths.current[columnID] >= newWidth ||
      newWidth <= CELL_MIN_WIDTH_IN_PX + MARGIN_IN_PX
    )
      return;

    columnWidths.current[columnID] = newWidth;
    setMeasurementsUpdated((currentVal) => currentVal + 1);
  };

  return (
    <CellMeasurementsContext.Provider
      value={{
        setWidthMeasurement,
        columnWidths: columnWidths.current,
        measurementsUpdated,
      }}
    >
      {children}
    </CellMeasurementsContext.Provider>
  );
}

export function useCellMeasurements({ columnID, columnType }) {
  const { setWidthMeasurement, columnWidths, measurementsUpdated } = useContext(
    CellMeasurementsContext
  );

  if (!measurementsUpdated) {
    throw new Error(
      "useCellMeasurements must be used within a CellMeasurementsParentProvider"
    );
  }

  const columnWidth = columnWidths[columnID];
  const width = useMemo(() => columnWidth || false, [columnWidth]);

  const [hasMeasured, setHasMeasured] = useState(false);

  if (columnID && columnType) {
    //create conditionals here to change width based on the column type.
  }

  const updateMeasurements = ({ width, height }) => {
    //console.log({ columnID, width });
    setWidthMeasurement(columnID, width);
    setHasMeasured(true);
  };

  const remeasureCell = (newValue = true) => {
    if (!newValue) setWidthMeasurement(columnID, 0);
    else setHasMeasured(false);
  };

  const MeasureCell = ({ children }) =>
    !hasMeasured ? (
      <MeasureComponent setMeasurements={updateMeasurements}>
        {children}
      </MeasureComponent>
    ) : null;

  return { width, MeasureCell, remeasureCell };
}
